export const CDNDomains = [
  "staging.cdn.content.pantheon.io",
  "cdn.staging.content.pantheon.io",
  "cdn.content.pantheon.io",
  "cdn.prod.pcc.pantheon.io",
  "cdn.staging.pcc.pantheon.io",
];
